import { Controller } from "@hotwired/stimulus"

// Dropzone per l'upload del PDF: evidenzia l'area al dragover,
// assegna i file trascinati all'input nascosto e invia il form.
// Prima dell'invio verifica tipo, dimensione e leggibilità del file:
// un FileReader che fallisce (file su cloud non scaricato, spostato,
// trascinato da una mail) non genera alcuna richiesta al server, quindi
// l'unico posto dove spiegare l'errore è qui.
export default class extends Controller {
  static targets = ["input", "idle", "busy", "error"]

  MAX_SIZE = 10 * 1024 * 1024

  dragover(event) {
    event.preventDefault()
    this.element.classList.add("border-emerald-600", "bg-emerald-50")
  }

  dragleave(event) {
    event.preventDefault()
    this.element.classList.remove("border-emerald-600", "bg-emerald-50")
  }

  drop(event) {
    event.preventDefault()
    this.dragleave(event)
    this.inputTarget.files = event.dataTransfer.files
    this.submit()
  }

  changed() {
    this.submit()
  }

  async submit() {
    const file = this.inputTarget.files[0]
    if (!file) return

    this.errorTarget.hidden = true
    const problem = await this.preflightProblem(file)
    if (problem) {
      this.showError(problem)
      return
    }

    this.element.closest("form").requestSubmit()
  }

  started() {
    this.idleTarget.hidden = true
    this.busyTarget.hidden = false
  }

  failed(event) {
    event.preventDefault()
    console.error("Direct upload fallito:", event.detail.error)
    const raw = String(event.detail.error || "")
    const message = raw.startsWith("Error reading ")
      ? this.unreadableMessage(raw.replace("Error reading ", ""))
      : `Caricamento fallito: ${raw}. Riprova.`
    this.showError(message)
  }

  showError(message) {
    this.idleTarget.hidden = false
    this.busyTarget.hidden = true
    this.errorTarget.textContent = message
    this.errorTarget.hidden = false
    this.inputTarget.value = ""
  }

  async preflightProblem(file) {
    const looksPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf")
    if (!looksPdf) return `"${file.name}" non sembra un PDF. Carica il PDF originale della fattura.`
    if (file.size === 0) return `"${file.name}" è vuoto (0 byte): salvalo di nuovo sul disco e riprova.`
    if (file.size > this.MAX_SIZE) return `"${file.name}" supera i 10 MB consentiti.`

    try {
      await file.slice(0, 16).arrayBuffer()
      return null
    } catch (error) {
      console.error("File non leggibile dal browser:", error)
      return this.unreadableMessage(file.name)
    }
  }

  unreadableMessage(name) {
    return `Il browser non riesce a leggere "${name}" dal disco. Succede se il file non è ancora ` +
      `scaricato da iCloud/Drive/OneDrive, se è stato spostato o modificato dopo la selezione, ` +
      `o se è stato trascinato direttamente da una mail. Copia il PDF in una cartella locale ` +
      `(es. Scrivania) e ricaricalo da lì.`
  }
}
